if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function() {
        menuHighlighting();
    });
} else {
    menuHighlighting();
}

function menuHighlighting() {
    let pathname = window.location.pathname;

    // workaround for english root page, otherwise we catch all links with a trailing slash and try to highlight them
    if (pathname === "/") {
        return;
    }

    // workaround for blog URL
    if (window.location.hostname === "blog.paessler.com") {
        pathname = "https://blog.paessler.com";
    }
    // workaround for kb URL
    if (
        window.location.hostname === "kb.paessler.com" ||
        window.location.hostname === "kb-staging.paessler.com"
    ) {
        pathname = "https://www.paessler.com/support/knowledgebase";
    }
    // workaround for partner app
    if (pathname.substring(0, 13) === "/app/partners") {
        pathname = "/partners/resellers";
    }
    // workaround for sensor hub
    if (pathname.substring(0, 11) === "/sensor-hub") {
        pathname = "/support/sensor-hub";
    }
    // workaround for press with and without language
    if (pathname.split("/")[1] === "press" || pathname.split("/")[2] === "press") {
        pathname = "/company/press-center";
    }
    // workaround for it-explained with and without language
    if (pathname.split("/")[1] === "it-explained" || pathname.split("/")[2] === "it-explained") {
        pathname = "/support/it-knowledge";
    }

    const mainNavigation = document.getElementById("main-nav");
    if (!mainNavigation) {
        return;
    }

    // check if link with the current pathname can be found in the navigation
    let navigationElements = mainNavigation.querySelectorAll(
        "a[href$='" + pathname + "']"
    );
    // if the link does not exist in the menu, check if the first part of path exists in the menu
    if (navigationElements.length === 0) {
        let firstUrlPart = "/" + pathname.split("/")[1];

        if (firstUrlPart.length === 3) {  // if we suspect the path to contain a language we check the first two parts
            pathname = firstUrlPart + "/" + pathname.split("/")[2];
        } else {
            pathname = firstUrlPart;
        }
        navigationElements = mainNavigation.querySelectorAll(
            "a[href='" + pathname + "']"
        );
    }
    // color in the main nav item
    if (navigationElements.length > 0) {
        let mainNavigationElement = navigationElements[0].closest("[data-main-menu]");

        if (navigationElements[0].closest("li").classList.contains("js-navigation-main-item")) {
            mainNavigationElement = navigationElements[0].closest(".js-navigation-main-item");
        }
        mainNavigationElement?.classList.add("text-cyan");
    }

    for (let topNavigation of document.querySelectorAll(".js-top-navigation")) {
        let topNavigationElements = topNavigation.querySelectorAll(
            "a[href$='" + pathname + "']"
        );
        if (topNavigationElements.length === 0) {  // fallback if we find nothing to highlight on the first try
            let firstUrlPart = "/" + pathname.split("/")[1];

            if (firstUrlPart.length === 3) {  // if we suspect the path to contain a language we check the first two parts
                pathname = firstUrlPart + "/" + pathname.split("/")[2];
            } else {
                pathname = firstUrlPart;
            }
            topNavigationElements = topNavigation.querySelectorAll(
                "a[href='" + pathname + "']"
            );
        }
        if (topNavigationElements.length > 0) {
            const topNavigationElement = topNavigationElements[0].closest(".js-top-navigation > li").querySelector("a");
            topNavigationElement?.classList.add("text-cyan");
        }
    }
}
